<template>
  <v-card style="margin-top: 20px" color="background">
    <v-card-title class="justify-center" style="font-size: 17px">
      <div style="width: 100%; text-align: center">
        <b>{{ $t('Invoice number') }}</b> <b>{{ invoice.number }}</b>
      </div>
    </v-card-title>
    <v-card-subtitle align="center">
      <v-container>
        <InvoiceImage v-if="fileName" ref="invoiceImage" :height="'unset'" :width="'100%'" :image="fileName" style="width: 100%" />
        <v-container>
          <v-row justify="center">
            <div class="centered">
              <div v-if="txt">
                {{ txt }}
              </div>
              <div v-if="payer">
                {{ payer + ' ' + $t('Pay') + ' ' + amount + ' € ' }}
              </div>
              <div v-if="receiverCif">
                {{ receiverCif }}
              </div>

              <div v-if="newPayerCif">
                {{ newPayerCif + ' ' + $t('Pay') + ' ' + newAmount + ' € ' }}
              </div>
              <div v-if="newReceiverCif">
                {{ newReceiverCif }}
              </div>
            </div>
          </v-row>
        </v-container>
      </v-container>
    </v-card-subtitle>
  </v-card>
</template>

<script>

import ApiRepository from "../repositories/ApiRepository";
import InvoiceImage from "../components/invoice/InvoiceImage";

export default {
    name: "ShowInvoiceInformation",
    components: {InvoiceImage},
    props: {
        invoice: {
            type: Object,
            default: null
        },
        txt: {type: String, default: null},
        payer: { type: String, default: null},
        amount: {type: Number, default: null},
        receiverCif: { type: String, default: null},
        newPayerCif: { type: String, default: null},
        newReceiverCif: { type: String, default: null},
        newAmount: {type: Number, default: null}
    },
    data () {
        return {
            fileName: ""
        };
    },
    created () {
        ApiRepository.getFilename(this.invoice._id.toString())
            .then((res) => {
                this.fileName = res.data.fileName;
            })
            .catch((err) => {
                console.log(err);
            });
    },
    methods: {
        show () {
        },
    }
};
</script>

<style scoped>
  .centered {
    border: #FF6961 2px solid;
    color: #FF6961;
    padding: 8px;
    position: absolute;
    font-weight: bold;
    top: 45%;
    font-size: 13px;
    -webkit-transform: rotate(25deg);
  }
</style>
